import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {TopPerformersWidgetState} from "./models/top-performers-widget.state";
import {TopPerformersWidgetConfig} from "./top-performers-widget.config";

export class TopPerformersWidgetStore extends BaseMobxStore {
  static injectables = [TopPerformersWidgetConfig, TopPerformersWidgetState];
}

